<template>
  <div class="register">
    <br />
      <h2>Register here!</h2>
    <br />

    <registration-form />
  </div>
</template>

<script>
export default {
  name: 'register'
}
</script>
